<template>
  <div :uk-slider="`autoplay:${autoplay}`" :style="`width:${width};`">
    <div class="uk-position-relative uk-visible-toggle uk-light" tabindex="-1">
      <div class="uk-slider-items">
        <component
          v-for="(image, i) in images"
          :key="i"
          :is="image.link ? 'a' : 'div'"
          :href="image.link ?? ''"
          :target="image.target ?? ''"
          class="uk-width-1-1"
        >
          <img
            :src="image.url"
            :alt="image.alt"
            :style="`object-fit:${objectFit};width:${width};height:${height}`"
          />
          <div class="uk-overlay uk-overlay-primary uk-position-bottom uk-text-center" v-if="image.bottomText">
            <p class="uk-margin-remove">{{ image.bottomText }}</p>
          </div>
        </component>
      </div>
      <a
        class="uk-position-center-left uk-position-small uk-hidden-hover"
        href
        uk-slidenav-previous
        uk-slider-item="previous"
        :style="sidenavStyle"
        @click="$event.currentTarget.blur()"
      ></a>
      <a
        class="uk-position-center-right uk-position-small uk-hidden-hover"
        href
        uk-slidenav-next
        uk-slider-item="next"
        :style="sidenavStyle"
        @click="$event.currentTarget.blur()"
      ></a>
    </div>
    <ul
      v-if="dotnav"
      class="uk-slider-nav uk-dotnav uk-flex-center uk-margin"
    ></ul>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  /**
   * 画像データオブジェクトの配列
   *
   * 画像データオブジェクト
   * {
   *   url: https://gazou_url/xxx.png, 画像URL（必須）
   *   alt: "画像の説明", 画像のalt（任意）
   *   link: "https://example.com" 画像をクリックしたときのリンク先URL（任意）
   *   target: "_blank" リンク先を新しいタブで開く場合は指定（任意）
   *   bottomText: "画像タイトル" 画像の下部に表示させるテキスト文字列 (任意)
   * }
   */
  images: {
    type: Array,
    default: [],
    required: true,
  },

  /**
   * スライドショーの幅
   * ex) 400px
   * デフォルト値（100%）のままにして、親要素でサイズ決める形の方がよさそう？
   */
  width: {
    type: String,
    default: "100%",
  },
  /**
   * スライドショーの高さ
   * ex) 300px
   */
  height: {
    type: String,
    default: "100%",
  },
  /**
   * object-fit（cssプロパティ）
   */
  objectFit: {
    type: String,
    default: "cover",
  },
  /**
   * 自動スライド
   */
  autoplay: {
    type: Boolean,
    default: false,
  },
  /**
   * スライド下に表示するドットナビ表示 ⚫︎⚪⚪︎
   */
  dotnav: {
    type: Boolean,
    default: true,
  },
  /**
   * 前後のスライドに移動するナビ（＜, ＞）のスタイル設定
   * ex）color:#fff;font-color:bold;
   */
  sidenavStyle: {
    type: String,
    default: "",
  },
});
</script>

<style lang="scss" scoped>
.uk-dotnav>*>* {
  border: 1px solid rgba(102, 102, 102, .4);
}
.uk-overlay {
  padding: 0.2rem;
  color: #fff;
  font-size: 0.75rem;
}
// タッチデバイスにはホバー概念が無くタップ時にボタンが一瞬表示されてしまうため非表示にする（他画像の存在はdotnavで示す）
@media (hover: none) {
  a[uk-slidenav-previous],
  a[uk-slidenav-next] {
    display: none !important;
  }
}
</style>